import React from 'react';

import { EventPerformance } from '../../models/models';

import EventService from '../../services/event.service';

import config from '../../config/config';

type EventListItemProps = {
  event: EventPerformance;
  teaser?: boolean
}

const VerticalEventDetail: React.FC<EventListItemProps> = ({ event }) => {

  const [periodPhrase, setPeriodPhrase] = React.useState<string>('');

  React.useEffect(() => {
    (async () => {
      // strange bug event days and years are sometimes strings but should be numbers instead
      setPeriodPhrase((await EventService.periodPrases({
        day: parseInt(event.day.toString()),              
        month: event.month,
        year: parseInt(event.year.toString()),
        period: event.period
      })).body || '');
      
    })();
  }, []);

  return (
    <div className="p-1 shadow-md text-left h-full">
      <div className="m-4 aspect-1">
        <img src={
          (
            event.thumbnail.toUpperCase().startsWith('HTTP://') ||
            event.thumbnail.toUpperCase().startsWith('HTTPS://') ||
            event.thumbnail.toUpperCase().startsWith('www.')
          ) ?
            event.thumbnail
          :
            config.ASSETS[config.ENVIRONMENT] + event.thumbnail
        } alt="Event Thumbnail" className="object-cover w-full h-full rounded" />
      </div>
      <div className="m-4 text-gray-400">

        <div className="my-2">
          { !(event.period === 'Once') &&
            <div className='text-lg font-semibold text-black'>
              { periodPhrase }
              <span className='text-md text-gray-600'>,&nbsp;starting&nbsp;</span>
            </div>
          }
          <div className="text-md font-semibold">{event.month} {event.day}, {event.year} at <span className='text-md text-gray-600'>{event.time}</span></div>
          <div className="text-gray-500">{
            event.website ?
              <a target="_blank" rel="noopener noreferrer" href={event.website}>{event.location}</a>
            :
              event.location
          }</div>
          {
            (!!event.addressa) && (
              <div className="text-blue-800">{event.addressa}</div>
            )
          }
          {
            (!!event.addressb) && (
              <div className="text-blue-800">{event.addressb}</div>
            )
          }
        </div>

        {/* <div className="text-gray-700 mb-4">{event.description}</div> */}

        <div className="my-2 relative overflow-y-scroll ">
          <div className="absolute bottom-0 left-0 w-full h-full"></div>
          <p className="text-black">
              {event.description}
          </p>
        </div>
      </div>
    </div>
  );
};

export default VerticalEventDetail;
